import { Component, OnInit, OnDestroy , ElementRef, ViewChild, AfterViewInit} from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { ConstantsService, SessionService } from '@app/base/core';
import { LandingService } from '@app/modules/landing/base';
import { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'app-contract',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit,  OnDestroy, AfterViewInit {
  ngAfterViewInit(): void {

    // Dispaying the Breadcrumb based on the user .
  }

// Defining the Constructor
  constructor( private route: ActivatedRoute,
    private router: Router,
    private http: LandingService,
    public sessionSvc: SessionService,
    public constantsSVc: ConstantsService,
    public config: SocoConfigurationService
    ) {this.buildFormGroup();  }
  private routeSubscription: any;
// Declaring the Variables
  BcaId: number;
  CostToServe = 0.00;
  paymentForm: FormGroup;
    // Building the form group
  buildFormGroup(): void {
    this.paymentForm = new FormGroup({
      BcaId: new FormControl(''),
    },
    { updateOn: 'blur' });
  }
  ngOnInit() {
     // Get ID and user from route params.
     this.routeSubscription = this.route.params.subscribe(params => {

      if (params['id']) {
        this.BcaId = (params['id']);
        this.paymentForm.controls['BcaId'].patchValue(this.BcaId);
      }
      if (params['user']) {
        this.sessionSvc.sourceToContract = (params['user']);
      }
    });

    const subscription = this.http.getBcaContractInfo(this.BcaId).subscribe(result => {
      if (subscription) {
        subscription.unsubscribe();
      }
      if (result.data != null) {
        this.BcaId = result.data[0].bcaId;
        this.CostToServe = result.data[0].customerOwedAmount;
        this.sessionSvc.projectName = result.data[0].projectName;
      }
    });
  }
  ngOnDestroy() {
  }
// Navigate to Payment Gateway
  goToPaymentGateway() {
      swal(this.constantsSVc.okSwal1, this.constantsSVc.paymentSwal);
}
  // Go To Back
  goToBack() {
      this.router.navigate([this.sessionSvc.paramLdc.toLocaleLowerCase(), 'builder', 'contract', this.sessionSvc.sourceToContract,
      this.BcaId]);
  }
}
